var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0C9.92912 0 6.61719 3.31193 6.61719 7.38281C6.61719 11.4537 9.92912 14.7656 14 14.7656C18.0709 14.7656 21.3828 11.4537 21.3828 7.38281C21.3828 3.31193 18.0709 0 14 0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1856 19.5888C21.1644 17.5365 18.4849 16.4062 15.6406 16.4062H12.3594C9.51519 16.4062 6.83561 17.5365 4.81436 19.5888C2.80301 21.631 1.69531 24.3268 1.69531 27.1797C1.69531 27.6327 2.06259 28 2.51562 28H25.4844C25.9374 28 26.3047 27.6327 26.3047 27.1797C26.3047 24.3268 25.197 21.631 23.1856 19.5888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.f499fe63f457e969e87e40eaf0d12c83.svg";
export { ForwardRef as ReactComponent };